import { CommonBackContent } from '../Layouts/CommonBackContent';

import APITopContent from './APITopContent';
import ChooseContent from './ChooseContent';
import APIFooterContent from './APIFooterContent';
import HLabelContent from '../Common/HLabelContent';
const HairpacaAPIContent = () => {
  return (
    <CommonBackContent>
      <HLabelContent hlabelPath="hairpaca-api" />
      <APITopContent />
      <ChooseContent />
      <APIFooterContent />
    </CommonBackContent>
  );
};

export default HairpacaAPIContent;
